import { motion } from "framer-motion";

interface CategoryTabsProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

const CategoryTabs = ({ categories, activeCategory, onCategoryChange }: CategoryTabsProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
      className="flex flex-wrap justify-center gap-2 md:gap-3"
    >
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`
            relative px-4 py-2 md:px-6 md:py-2.5 text-xs md:text-sm font-medium tracking-wider uppercase
            transition-all duration-300 rounded-full border
            ${activeCategory === category
              ? "bg-primary text-primary-foreground border-primary glow-ring"
              : "bg-transparent text-muted-foreground border-border hover:border-primary/50 hover:text-foreground"
            }
          `}
        >
          {category}
          {activeCategory === category && (
            <motion.div
              layoutId="activeTab"
              className="absolute inset-0 bg-primary rounded-full -z-10"
              transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
            />
          )}
        </button>
      ))}
    </motion.div>
  );
};

export default CategoryTabs;
